export const FAQ_CATEGORIES = [
  {
    id: "inspection-controle",
    anchor: "inspection-audit-controle-qualite",
    title: "Inspection, audit et contrôle qualité",
    cta: { label: "Découvrir nos prestations d'inspection et de contrôle", to: "/qualite-controle" },
    link: { label: "Nos prestations d'inspection et de contrôle qualité", to: "/qualite-controle" },
    questions: [
      {
        q: "Comment fonctionne un audit de contrôle qualité des raccordements FTTH ?",
        a: [
          "Un audit de contrôle qualité des raccordements FTTH vise à vérifier la qualité des installations réalisées au regard des exigences techniques et des référentiels applicables à la mission.",
          "Selon le périmètre convenu avec le donneur d'ordre, la démarche peut comprendre la préparation de la mission, l'examen des informations disponibles, les vérifications sur le terrain, l'identification des écarts, la documentation des constats et la restitution des résultats.",
          "Les observations peuvent ensuite être structurées dans un compte rendu permettant de faciliter l'analyse des anomalies et le suivi des actions correctives par les interlocuteurs concernés.",
          "ATLAS THD propose des prestations d'inspection et de contrôle adaptées aux besoins définis avec ses clients. Les modalités précises de chaque audit sont à convenir avant l'intervention.",
        ],
      },
      {
        q: "Quelle est la différence entre une inspection technique et un audit qualité ?",
        a: [
          "L'inspection technique porte principalement sur l'examen d'une installation, d'un raccordement ou d'un point technique afin d'identifier les anomalies et les écarts constatés.",
          "L'audit qualité adopte une approche plus globale, pouvant inclure l'analyse d'un ensemble de contrôles, l'identification de défauts récurrents et la synthèse des constats selon le périmètre de la mission.",
          "Ces deux démarches sont complémentaires : l'inspection permet de documenter des situations concrètes, tandis que l'audit aide à analyser les résultats et à identifier des axes d'amélioration.",
        ],
      },
      {
        q: "Quels éléments peuvent être vérifiés lors d'un contrôle qualité FTTH ?",
        a: [
          "Les points contrôlés dépendent du référentiel technique, du cahier des charges et du périmètre de la mission.",
          "Ils peuvent notamment concerner la qualité d'exécution du raccordement, l'état apparent des installations, le cheminement des câbles, les points de raccordement, le repérage, la propreté de l'installation et la présence d'anomalies visibles.",
          "Les contrôles peuvent également porter sur la documentation et la traçabilité des travaux lorsque ces éléments font partie des exigences du donneur d'ordre.",
          "La liste définitive des vérifications doit être définie en fonction des spécifications applicables au chantier.",
        ],
      },
      {
        q: "Comment les non-conformités sont-elles identifiées et documentées ?",
        a: [
          "Lorsqu'un écart est constaté, il doit être décrit de manière claire, précise et exploitable.",
          "Selon les exigences de la mission, la documentation peut comprendre la localisation du point contrôlé, une description du constat, des photographies justificatives, la référence du critère concerné et les informations nécessaires à son suivi.",
          "La qualification d'une non-conformité doit s'appuyer sur les exigences applicables et non sur une appréciation arbitraire.",
          "Cette méthode facilite la compréhension des écarts par les équipes techniques et les responsables qualité.",
        ],
      },
      {
        q: "À quoi sert un rapport de contrôle qualité ?",
        a: [
          "Un rapport de contrôle qualité formalise les vérifications réalisées et les observations recueillies pendant la mission.",
          "Selon le format convenu, il peut présenter le périmètre contrôlé, les résultats, les anomalies identifiées, les éléments justificatifs et les informations utiles au suivi des écarts.",
          "Il permet au donneur d'ordre de disposer d'une restitution structurée et de faciliter les décisions concernant les éventuelles actions correctives.",
        ],
      },
      {
        q: "Comment le contrôle qualité contribue-t-il à l'amélioration des réseaux fibre optique ?",
        a: [
          "Le contrôle qualité permet de mieux identifier les anomalies constatées sur les raccordements et les installations.",
          "Lorsque les informations sont suffisamment documentées et consolidées, elles peuvent aider à repérer les défauts récurrents, à comprendre certaines difficultés d'exécution et à orienter les actions d'amélioration.",
          "Les résultats dépendent toutefois du périmètre contrôlé, de la qualité des informations recueillies et de leur exploitation par les équipes concernées.",
        ],
      },
      {
        q: "Quelle est la différence entre un contrôle sur le terrain et un contrôle documentaire ou en back-office ?",
        a: [
          "Le contrôle sur le terrain permet d'examiner directement les installations et les points techniques accessibles dans le cadre de la mission.",
          "Le contrôle documentaire ou en back-office repose sur l'analyse des informations disponibles, telles que les dossiers d'intervention, les photographies, les comptes rendus et les éléments de suivi.",
          "Ces approches peuvent être complémentaires. Le choix de la méthode dépend de l'objectif du contrôle, des données disponibles et des exigences du donneur d'ordre.",
        ],
      },
    ],
  },
  {
    id: "vqse-qhse",
    anchor: "vqse-qhse-remontees-terrain",
    title: "VQSE, QHSE et remontées terrain",
    cta: { label: "Voir notre activité qualité et remontées terrain", to: "/qualite-controle" },
    link: { label: "Notre activité qualité et remontées terrain", to: "/qualite-controle" },
    questions: [
      {
        q: "Que signifient VQSE et QHSE dans le domaine des télécommunications ?",
        a: [
          "QHSE signifie généralement Qualité, Hygiène, Sécurité et Environnement.",
          "VQSE est un sigle dont le sens exact peut varier selon les organisations et les référentiels internes. Dans le contexte des opérations terrain, il peut notamment être associé à la vigilance, à la qualité, à la sécurité et à l'environnement.",
          "Les termes employés dans une mission doivent correspondre aux définitions retenues par le client et à ses procédures.",
        ],
      },
      {
        q: "Que comprend une remontée VQSE sur un chantier fibre optique ?",
        a: [
          "Une remontée VQSE consiste à transmettre des informations pertinentes observées lors d'une intervention, conformément aux procédures applicables.",
          "Selon la mission, elle peut porter sur un défaut de réalisation, un écart technique, une anomalie constatée, une situation présentant un risque ou un point nécessitant une attention particulière.",
          "Une remontée exploitable doit être claire, contextualisée et suffisamment documentée pour permettre au responsable concerné d'en comprendre la nature et d'en assurer le suivi.",
        ],
      },
      {
        q: "Pourquoi la traçabilité des contrôles est-elle importante ?",
        a: [
          "La traçabilité permet de retrouver les informations essentielles relatives à une vérification : le point contrôlé, la date lorsque disponible, les observations, les justificatifs et les suites données.",
          "Elle facilite les échanges entre les équipes terrain, les responsables qualité et les donneurs d'ordre.",
          "Les modalités de traçabilité dépendent des outils, des procédures et des exigences définis pour chaque mission.",
        ],
      },
      {
        q: "Comment les anomalies détectées peuvent-elles être suivies ?",
        a: [
          "Le suivi d'une anomalie repose sur une description précise du constat, son attribution au bon interlocuteur et la définition des modalités de traitement.",
          "Selon le dispositif convenu, le suivi peut inclure une demande de reprise, la transmission d'un justificatif, une nouvelle vérification ou la clôture documentée de l'écart.",
        ],
      },
    ],
  },
  {
    id: "raccordement",
    anchor: "raccordement-ftto-ftth",
    title: "Raccordement FTTO et FTTH",
    cta: { label: "Découvrir nos raccordements fibre FTTO / FTTH", to: "/terrain-fibre" },
    link: { label: "Nos raccordements fibre FTTO / FTTH", to: "/terrain-fibre" },
    questions: [
      {
        q: "Quelle est la différence entre FTTO et FTTH ?",
        a: [
          "Le FTTH, ou Fiber To The Home, désigne la fibre optique jusqu'au logement. Il concerne notamment les raccordements résidentiels.",
          "Le FTTO, ou Fiber To The Office, désigne une connexion fibre destinée aux entreprises et aux sites professionnels.",
          "Les architectures techniques, les offres de connectivité et les niveaux de service dépendent du projet, de l'opérateur et du contrat souscrit.",
          "ATLAS THD propose des prestations de raccordement FTTO pour les professionnels et FTTH pour les particuliers, selon les conditions techniques et le périmètre d'intervention.",
        ],
      },
      {
        q: "Comment se déroule un raccordement fibre optique ?",
        a: [
          "Le déroulement dépend du type de raccordement, du bâtiment, de l'infrastructure existante et des conditions techniques du site.",
          "De manière générale, l'intervention nécessite de prendre connaissance du besoin, de vérifier les conditions d'accès et de raccordement, de réaliser les opérations prévues, puis de vérifier la qualité d'exécution selon le périmètre convenu.",
          "Les contraintes particulières et les éventuelles opérations complémentaires sont évaluées en fonction du chantier.",
        ],
      },
      {
        q: "Quelles informations fournir pour demander un devis de raccordement FTTO ?",
        a: [
          "Pour étudier une demande FTTO, il est utile de préciser l'adresse ou la localisation du site, la nature du bâtiment, le besoin de raccordement, les contraintes techniques connues et les coordonnées de l'interlocuteur.",
          "Les plans, documents techniques ou informations sur l'infrastructure existante peuvent également faciliter l'étude lorsqu'ils sont disponibles.",
          "ATLAS THD peut ensuite examiner les informations transmises et déterminer les éléments nécessaires à l'évaluation de la demande.",
        ],
      },
      {
        q: "Comment demander des informations sur un raccordement FTTH pour un particulier ?",
        a: [
          "Le particulier peut contacter ATLAS THD en précisant sa commune, la nature du logement et les informations dont il dispose sur son projet de raccordement.",
          "L'étude dépend notamment de l'éligibilité du logement, de l'infrastructure existante et des conditions techniques de réalisation.",
          "Aucune éligibilité ni date d'intervention ne peut être garantie sans vérification préalable.",
        ],
      },
    ],
  },
  {
    id: "organisation",
    anchor: "organisation-missions-donneurs-ordre",
    title: "Organisation des missions et donneurs d'ordre",
    cta: { label: "Échanger avec nous sur votre mission", to: "/contact" },
    link: { label: "Échanger avec nous sur votre mission", to: "/contact" },
    questions: [
      {
        q: "Comment organiser une mission d'inspection ou de contrôle qualité ?",
        a: [
          "Une mission se prépare en définissant les objectifs, le périmètre d'intervention, les sites ou points techniques concernés, les référentiels applicables et le format de restitution attendu.",
          "Les modalités d'accès, les contraintes de sécurité, les interlocuteurs et les délais souhaités doivent également être précisés.",
          "Cette préparation permet de clarifier les attentes et de définir des conditions de réalisation adaptées à la mission.",
        ],
      },
      {
        q: "Quels documents préparer avant un audit de raccordements FTTH ?",
        a: [
          "Selon le contexte, les documents utiles peuvent comprendre le cahier des charges, les référentiels techniques applicables, la liste des points à contrôler, les dossiers d'intervention disponibles et les modèles de comptes rendus attendus.",
          "Les consignes d'accès aux sites et les règles de sécurité doivent également être communiquées lorsque cela est nécessaire.",
          "La liste définitive dépend du donneur d'ordre et du périmètre convenu.",
        ],
      },
      {
        q: "Quels sont les délais pour une intervention ou une mission d'audit ?",
        a: [
          "Les délais dépendent du volume de points à contrôler, de la localisation des sites, de leur accessibilité, du niveau de préparation du dossier et des modalités de restitution.",
          "Après réception des informations nécessaires, ATLAS THD peut examiner la demande et échanger avec le client sur un calendrier adapté.",
        ],
      },
      {
        q: "Dans quelles zones géographiques ATLAS THD intervient-elle ?",
        a: [
          "La zone d'intervention est confirmée avec ATLAS THD en fonction du type de prestation, du lieu du chantier et des conditions de réalisation.",
          "Les demandes peuvent être transmises par téléphone ou par e-mail afin d'étudier leur faisabilité.",
        ],
      },
      {
        q: "Comment demander un devis pour une mission de contrôle qualité ?",
        a: [
          "Pour préparer une demande, indiquez le type de mission, la localisation des sites, le volume estimé de raccordements ou de points techniques, le périmètre des contrôles et le format de restitution souhaité.",
          "Si vous disposez d'un cahier des charges ou d'un référentiel technique, vous pouvez également le préciser lors du premier échange.",
          "ATLAS THD pourra alors examiner le besoin et échanger avec vous sur les modalités de la mission.",
        ],
      },
      {
        q: "ATLAS THD réalise-t-elle uniquement des contrôles ou également des raccordements ?",
        a: [
          "ATLAS THD développe deux activités complémentaires : les raccordements fibre optique FTTO et FTTH, ainsi que les prestations d'inspection technique, de contrôle de conformité, d'audit qualité et de remontées terrain.",
          "Cette double expertise permet de répondre à différents besoins liés aux interventions et à la qualité des infrastructures fibre optique.",
          "Le contenu exact de chaque prestation est défini en fonction de la demande et du périmètre convenu.",
        ],
      },
    ],
  },
  {
    id: "commercial",
    anchor: "questions-commerciales",
    title: "Questions commerciales",
    cta: { label: "Découvrir nos réalisations", to: "/realisations" },
    link: { label: "Nos réalisations terrain et missions qualité", to: "/realisations" },
    questions: [
      {
        q: "Comment contacter ATLAS THD pour présenter un projet ?",
        a: [
          "Vous pouvez contacter ATLAS THD par téléphone au 06 05 76 50 66 ou par e-mail à Contact.pro@atlasthd.com.",
          "Précisez votre entreprise, votre besoin, le type de prestation recherché et les principales informations disponibles sur votre projet.",
          "Ces éléments permettront de faciliter le premier échange et d'orienter votre demande.",
        ],
      },
      {
        q: "ATLAS THD accompagne-t-elle les opérateurs, les entreprises de rang 1 et les syndicats territoriaux ?",
        a: [
          "ATLAS THD cible les acteurs professionnels des télécommunications, notamment les opérateurs, les entreprises intervenant dans le déploiement des réseaux et les structures territoriales concernées par les infrastructures numériques.",
          "Les prestations proposées peuvent porter sur le raccordement, l'inspection, le contrôle de conformité et la qualité terrain, selon les besoins et les conditions convenus avec chaque donneur d'ordre.",
        ],
      },
      {
        q: "Comment devenir partenaire ou référencer ATLAS THD comme prestataire ?",
        a: [
          "Les entreprises souhaitant étudier une collaboration peuvent contacter ATLAS THD en présentant leur activité, les prestations recherchées, leur périmètre d'intervention et leurs exigences techniques.",
          "Les modalités de référencement, les documents nécessaires, les assurances et les éventuelles qualifications requises sont étudiés en fonction des exigences du donneur d'ordre.",
        ],
      },
    ],
  },
];

export const FAQ_FLAT = FAQ_CATEGORIES.flatMap((c) => c.questions);
